export const STATUS = {
    OK: "OK",
    ERROR: "ERROR",
    LOADING: "LOADING",
    PENDING: "PENDING"
}